import { Box, Chip, TableBody, TableCell, TableRow } from '@material-ui/core';
import React from 'react';
import AppTable from "./Component/Table/AppTable";
// import InputSearch from 'components/Input/InputSearch';
import AppColor from 'utilities/AppColor';

const headCells = [
    {
        id: "accountSoftware",
        numeric: "left",
        disablePadding: false,
        label: "label.accountSoftware",
        sort: false,
    },
    {
        id: "status",
        numeric: "left",
        disablePadding: false,
        label: "label.status",
        sort: false,
    }
];

const data = [
    {
        id: 1,
        accountSoftware: 'Xero',
        status: 'In-use'
    },
    {
        id: 2,
        accountSoftware: 'Quickbooks',
        status: 'In-use'
    }
];

const AccountSoftwareManagement = () => {

    return (
        <Box>
            {/* <Box my={3}>
                <InputSearch  />
            </Box> */}
            <AppTable
                headCells={headCells}
                rowCount={data.length}
            
            >
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell>{row.accountSoftware}</TableCell>
                            <TableCell>
                                <Chip
                                    style={{
                                        backgroundColor: AppColor.green,
                                        color: AppColor.white,
                                    }}
                                    label={row.status}  
                                />
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </AppTable>
        </Box>
    )
}

export default AccountSoftwareManagement;
